import React from 'react';
const Profile = React.lazy(() => import('./pages/profile'));
const Bank = React.lazy(() => import('./pages/bank'));
const Service = React.lazy(() => import('./pages/service'));
const Manage = React.lazy(() => import('./pages/manage'));
const InternetProfile = React.lazy(() => import('./pages/internetProfile'));
const EmailKYC = React.lazy(() => import('./pages/emailKyc'));
const AssistedMode = React.lazy(() => import('./pages/assistedMode'));
const DataDeletePoint = React.lazy(() => import('./pages/ClientDelete'));
const Products = React.lazy(() => import('./pages/products'));
const Pricing = React.lazy(() => import('./pages/pricing'));
const Dashboard = React.lazy(() => import('./pages/dashboard'));
const User = React.lazy(() => import('./pages/user'));
const Reports = React.lazy(() => import('./pages/reports'));
const PanStatusSearch = React.lazy(() => import('./pages/PansStatus'));
const DataPoint = React.lazy(() => import('./pages/DataPoint')); // Refactor Code
const ChangePassword = React.lazy(() => import('./pages/changePassword'));
const Strategy = React.lazy(() => import('./pages/strategy'));
const RiskProfile = React.lazy(
  () => import('./pages/RiskProfilerComponents/RiskProfilerManage'),
);
const AdditionalQuestionnaire = React.lazy(
  () => import('./pages/RiskProfilerComponents/RiskProfileConsent'),
);
const Research = React.lazy(() => import('./pages/Research/Research'));
const ResearchService = React.lazy(() => import('./pages/Research/researchService'));
const ResearchReports = React.lazy(() => import('./pages/Research/researchReport'));
const ResearchExcel = React.lazy(() => import('./pages/Research/researchExcel'));
const KRACreateStatus = React.lazy(() => import('./pages/KRA/KraCreateStatus'));
const CKYCCreateStatus = React.lazy(() => import('./pages/CKYC/CKYCCreateStatus'));
const RoleMaster = React.lazy(() => import('./pages/roleMaster'));
const RoleMenuAccess = React.lazy(() => import('./pages/roleMenuAccess'));
const MasterSuperadmin = React.lazy(() => import('./pages/SuperAdmin/mastersSuperadmin'));
const PaymentDetails = React.lazy(() => import('./pages/SuperAdmin/paymentDetails'));
const ProductConfiguration = React.lazy(() => import('./pages/SuperAdmin/productConfiguration'));
const TenantsReports = React.lazy(() => import('./pages/SuperAdmin/tenantsReports'));
const Encryption = React.lazy(() => import('./pages/SuperAdmin/encryption'));
const CheckerReports = React.lazy(() => import('./pages/checkerReports'));
const KYCDataComparison = React.lazy(() => import('./pages/KYCDataComparison'));
const Estamp = React.lazy(() => import('./pages/estampManagement'));
const CounterEsignReports = React.lazy(() => import('./pages/CounterEsignReports'));

export const mapComponents = {
  Profile,
  Bank,
  Service,
  Manage,
  InternetProfile,
  EmailKYC,
  AssistedMode,
  DataDeletePoint,
  Products,
  Pricing,
  Dashboard,
  User,
  Reports,
  PanStatusSearch,
  DataPoint,
  ChangePassword,
  Strategy,
  RiskProfile,
  AdditionalQuestionnaire,
  Research,
  ResearchService,
  ResearchReports,
  ResearchExcel,
  KRACreateStatus,
  CKYCCreateStatus,
  RoleMaster,
  RoleMenuAccess,
  MasterSuperadmin,
  PaymentDetails,
  ProductConfiguration,
  TenantsReports,
  Encryption,
  CheckerReports,
  KYCDataComparison,
  Estamp,
  CounterEsignReports,
};
